import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _dec, _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import { Box, Callout, Flex, Heading, Text } from 'core/components';
import { Field, RadioGroup, Select, formConsumer } from 'core/form';
import { inject, observer } from 'mobx-react';
function getGuidedModeDimensions(_ref, _dimensionList) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? '' : _ref$type;
  if (type === 'site') {
    return [{
      label: 'Site Name',
      value: 'i_device_site_name'
    }];
  }
  if (type === 'device') {
    return [{
      label: 'Device Name',
      value: 'i_device_name'
    }];
  }
  if (type === 'country') {
    return [{
      label: 'Country',
      value: 'i_device_site_country'
    }];
  }

  // TODO: Once we're enhancing our dimensions with this parametricType field, we can filter validDimensions here

  return [];
}
var MetricsExplorerGuidedModeBehavior = (_dec = inject('$metrics'), _dec(_class = formConsumer(_class = observer(_class = /*#__PURE__*/function (_Component) {
  function MetricsExplorerGuidedModeBehavior() {
    var _this;
    _classCallCheck(this, MetricsExplorerGuidedModeBehavior);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MetricsExplorerGuidedModeBehavior, [].concat(args));
    _this.state = {
      measurementDimensions: null,
      guidedModeDimensions: null
    };
    /**
     * Reset form fields to "ignore" state - clears options and validation rules
     */
    _this.resetParametricFields = function () {
      var form = _this.props.form;
      form.getField('parametric_overrides.filterField').setOptions();
      form.getField('parametric_overrides.operator').setOptions();
      form.getField('parametric_overrides.filterField').setRules('');
      form.getField('parametric_overrides.operator').setRules('');
    };
    /**
     * Set form fields to require validation
     */
    _this.setParametricFieldsRequired = function () {
      var form = _this.props.form;
      form.getField('parametric_overrides.filterField').setRules('required');
      form.getField('parametric_overrides.operator').setRules('required');
    };
    _this.onParametricModeChange = function (_, value) {
      if (value === 'ignore') {
        _this.resetParametricFields();
      } else {
        _this.setParametricFieldsRequired();
      }
    };
    _this.onParametricFieldChange = function (_, value) {
      var _filterOperatorOption, _form$getField;
      var _this$props = _this.props,
        form = _this$props.form,
        filterOperatorOptions = _this$props.filterOperatorOptions,
        standardFilterOperators = _this$props.standardFilterOperators;
      var operators = (_filterOperatorOption = filterOperatorOptions === null || filterOperatorOptions === void 0 ? void 0 : filterOperatorOptions[value]) !== null && _filterOperatorOption !== void 0 ? _filterOperatorOption : standardFilterOperators;
      var parametricOperatorField = form === null || form === void 0 || (_form$getField = form.getField) === null || _form$getField === void 0 ? void 0 : _form$getField.call(form, 'parametric_overrides.operator');
      var parametricOperator = parametricOperatorField === null || parametricOperatorField === void 0 ? void 0 : parametricOperatorField.getValue();

      // Set operator as first available option if current value is not valid
      if (parametricOperator && !(parametricOperator in operators)) {
        parametricOperatorField === null || parametricOperatorField === void 0 || parametricOperatorField.setValue(Object.keys(filterOperatorOptions)[0]);
      }
    };
    _this.getMeasurementDimensions = function (measurement) {
      var _measurementWithMetad, _measurementWithMetad2;
      var $metrics = _this.props.$metrics;
      if (!measurement) {
        return null;
      }
      var measurementWithMetadata = $metrics.measurementModel(measurement);
      return (_measurementWithMetad = measurementWithMetadata === null || measurementWithMetadata === void 0 || (_measurementWithMetad2 = measurementWithMetadata.storage) === null || _measurementWithMetad2 === void 0 ? void 0 : _measurementWithMetad2.Dimensions) !== null && _measurementWithMetad !== void 0 ? _measurementWithMetad : null;
    };
    _this.getGuidedModeDimensions = function (parametricType, measurementDimensions) {
      if (!parametricType || !measurementDimensions) {
        return null;
      }
      return getGuidedModeDimensions(parametricType, measurementDimensions);
    };
    _this.syncFromProps = function (prevProps) {
      var _prevProps$parametric;
      var _this$props2 = _this.props,
        measurement = _this$props2.measurement,
        parametricType = _this$props2.parametricType,
        form = _this$props2.form;
      var measurementDimensions = _this.state.measurementDimensions;
      var measurementChanged = !prevProps || measurement !== prevProps.measurement;
      var parametricTypeChanged = !prevProps || (parametricType === null || parametricType === void 0 ? void 0 : parametricType.type) !== ((_prevProps$parametric = prevProps.parametricType) === null || _prevProps$parametric === void 0 ? void 0 : _prevProps$parametric.type);
      if (!measurementChanged && !parametricTypeChanged) {
        return;
      }
      var currentMeasurementDimensions = measurementChanged ? _this.getMeasurementDimensions(measurement) : measurementDimensions;
      var guidedModeDimensions = _this.getGuidedModeDimensions(parametricType, currentMeasurementDimensions);

      // If there are no valid dimensions for guided mode, reset parametric mode to "ignore" and clear fields
      // Do not want to require valid parametric field/operator if there are no valid options to select from
      if (guidedModeDimensions && guidedModeDimensions.length === 0) {
        form.setValue('parametric_mode', 'ignore');
        _this.resetParametricFields();
      }
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          measurementDimensions: currentMeasurementDimensions,
          guidedModeDimensions: guidedModeDimensions
        });
      });
    };
    return _this;
  }
  _inherits(MetricsExplorerGuidedModeBehavior, _Component);
  return _createClass(MetricsExplorerGuidedModeBehavior, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncFromProps();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.syncFromProps(prevProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _availableFiltersConf, _filterFields$filterG, _guidedModeDimensions, _guidedModeDimensions2;
      var _this$props3 = this.props,
        availableFiltersConfig = _this$props3.availableFiltersConfig,
        parametricMode = _this$props3.parametricMode,
        filterOperatorOptions = _this$props3.filterOperatorOptions,
        standardFilterOperators = _this$props3.standardFilterOperators,
        _this$props3$disabled = _this$props3.disabled,
        disabled = _this$props3$disabled === void 0 ? false : _this$props3$disabled,
        measurement = _this$props3.measurement,
        form = _this$props3.form,
        filterFields = _this$props3.filterFields;
      var guidedModeDimensions = this.state.guidedModeDimensions;

      // Default to first available filter if current value is not valid - this can happen when switching measurements or parametric types and the previously selected filter field is not available
      var selectedParametricFilter = form.getValue('parametric_overrides.filterField') || ((_availableFiltersConf = availableFiltersConfig.availableFilters[0]) === null || _availableFiltersConf === void 0 ? void 0 : _availableFiltersConf.value);
      var parametricOperatorOptions = filterOperatorOptions[selectedParametricFilter] || standardFilterOperators;
      var shouldRenderOperatorField = parametricMode === 'override_all' || parametricMode === 'add_group';
      var hasOptions = Array.isArray(guidedModeDimensions) && guidedModeDimensions.length > 0;
      var measurementDimensions = this.state.measurementDimensions;
      var activeQueryFilters = filterFields === null || filterFields === void 0 || (_filterFields$filterG = filterFields.filterGroups) === null || _filterFields$filterG === void 0 ? void 0 : _filterFields$filterG.flatMap(function (filterGroup) {
        var _filterGroup$filters;
        return (filterGroup === null || filterGroup === void 0 || (_filterGroup$filters = filterGroup.filters) === null || _filterGroup$filters === void 0 ? void 0 : _filterGroup$filters.map(function (filter) {
          var _measurementDimension;
          return (measurementDimensions === null || measurementDimensions === void 0 || (_measurementDimension = measurementDimensions[filter.filterField]) === null || _measurementDimension === void 0 ? void 0 : _measurementDimension.QueryColumn) || filter.filterField;
        })) || [];
      });
      var hasOverrideSpecificOption = (_guidedModeDimensions = guidedModeDimensions === null || guidedModeDimensions === void 0 || (_guidedModeDimensions2 = guidedModeDimensions.some) === null || _guidedModeDimensions2 === void 0 ? void 0 : _guidedModeDimensions2.call(guidedModeDimensions, function (dimension) {
        return activeQueryFilters === null || activeQueryFilters === void 0 ? void 0 : activeQueryFilters.includes(dimension.value);
      })) !== null && _guidedModeDimensions !== void 0 ? _guidedModeDimensions : false;
      return /*#__PURE__*/React.createElement(Flex, {
        flexDirection: "column",
        className: "overflow-auto",
        flexAuto: true
      }, /*#__PURE__*/React.createElement(Heading, {
        level: 6
      }, "Panel Guided Mode Behavior"), /*#__PURE__*/React.createElement(Text, {
        muted: true
      }, "Select the effect you want the user's input to have on this panel"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Field, {
        name: "parametric_mode",
        className: "no-margin",
        onChange: this.onParametricModeChange,
        labelStyle: {
          textTransform: 'none'
        },
        showLabel: false,
        disabled: !measurement || !hasOptions || disabled
      }, /*#__PURE__*/React.createElement(RadioGroup, {
        inline: false,
        disabledOptions: hasOverrideSpecificOption ? [] : ['override_specific']
      }))), measurement && !hasOptions && /*#__PURE__*/React.createElement(Callout, {
        p: 2,
        mt: 2,
        intent: "warning",
        title: "No Valid Guided Mode Dimensions"
      }, "This measurement does not have any valid dimensions for filtering based on the selected Guided Mode category. This panel will ignore any Guided Mode input."), !measurement && /*#__PURE__*/React.createElement(Callout, {
        p: 2,
        mt: 2,
        intent: "danger",
        title: "Missing Valid Query"
      }, "Please select a valid query for this dashboard item before configuring the field and/or operator."), parametricMode !== 'ignore' && measurement && /*#__PURE__*/React.createElement(Callout, {
        p: 2,
        mt: 4
      }, parametricMode === 'override_all' && /*#__PURE__*/React.createElement("p", null, "Ignore panels existing filters and add a new filter group:"), parametricMode === 'override_specific' && /*#__PURE__*/React.createElement("p", null, "Overriding all existing filters that contain:"), parametricMode === 'add_group' && /*#__PURE__*/React.createElement("p", null, "Add a new filter group:"), /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Field, {
        name: "parametric_overrides.filterField",
        disabled: disabled,
        options: guidedModeDimensions,
        onChange: this.onParametricFieldChange
      }, /*#__PURE__*/React.createElement(Select, {
        menuWidth: 350
      })), shouldRenderOperatorField && /*#__PURE__*/React.createElement(Field, {
        name: "parametric_overrides.operator",
        className: "no-margin",
        disabled: disabled,
        options: parametricOperatorOptions
      }, /*#__PURE__*/React.createElement(Select, {
        menuWidth: 350
      })))));
    }
  }]);
}(Component)) || _class) || _class) || _class);
export { MetricsExplorerGuidedModeBehavior as default };